module.exports = __webpack_public_path__ + "static/scale-model-of-segs-in-the-city-in-baltimore-maryland-300dbdd087a1c3342341383a101aa498.png";